module.exports = __webpack_public_path__ + "static/media/17@1024w.46578dc7.jpg";